var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "phywe-item-accordion accordion" }, [
    _vm.komponente.length > 0
      ? _c(
          "div",
          { staticClass: "widget komponent-off mb-5 mt-5 mt-lg-0" },
          [
            _c("h3", [
              _vm._v(
                _vm._s(_vm.$translate("Phywe::Template.singleBestandteil"))
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.komponente, function(result) {
              return _c("div", { staticClass: "componentoff" }, [
                result.more.data.images.all
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-4 text-center" }, [
                        result.more.data.images.all.length > 0
                          ? _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src: result.more.data.images.all[0].urlMiddle
                              }
                            })
                          : _c("img", {
                              staticClass: "img-fluid",
                              attrs: { src: "/images/produkte/no_image.png" }
                            })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-8" }, [
                        _c("a", {
                          staticClass: "h3 d-block",
                          attrs: { href: _vm._f("correctLang")(result, "url") },
                          domProps: {
                            innerHTML: _vm._s(result.more.data.texts.name1)
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "single-headline" }, [
                          _c("p", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell2"
                                  )
                                ) +
                                "\n                " +
                                _vm._s(result.more.data.variation.number) +
                                "\n                " +
                                _vm._s(
                                  _vm.$translate("Phywe::Template.globalType")
                                ) +
                                " Set\n              "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pricebox" },
                          [
                            result.more.data.variation.availability.id !== 7 &&
                            result.more.data.variation.availability.id !== 6
                              ? _c(
                                  "div",
                                  { staticClass: "availbox" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Phywe::Template.singleLieferzeit"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                    _vm.PID == 49089
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "availability badge availability-1"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Phywe::Template.singleLieferzeitSchweiz"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      : [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                "availability badge availability-" +
                                                result.more.data.variation
                                                  .availability.id
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      result.more.data.variation
                                                        .availability.names.name
                                                    ) +
                                                    "\n                    "
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.PID !== 49091
                              ? [
                                  result.more.data.prices.default.data
                                    .basePriceNet != 0
                                    ? [
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("currency")(
                                                  result.more.data.prices
                                                    .default.data.basePriceNet
                                                )
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.itemExclVAT"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-normal" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("currency")(
                                                  result.more.data.prices
                                                    .default.data.basePrice
                                                )
                                              ) +
                                                " " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.itemInclVAT"
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.current.texts.description
      ? _c(
          "div",
          { staticClass: "card", attrs: { "data-step": "description" } },
          [
            _c("div", { staticClass: "card-header" }, [
              _c("h2", { staticClass: "mb-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "d-flex btn btn-link btn-block text-left",
                    attrs: {
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": "#beschreibung",
                      "aria-expanded": "true",
                      "aria-controls": "collapseOne"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Phywe::Template.sbindingBeschreibung")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "flex-fill ml-3 fa fa-caret-down" })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse show",
                attrs: { id: "beschreibung", "aria-labelledby": "description" }
              },
              [
                _c("div", {
                  staticClass: "card-body px-0",
                  domProps: { innerHTML: _vm._s(_vm.current.texts.description) }
                })
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.variationLength
      ? _c(
          "div",
          { staticClass: "card", attrs: { "data-step": "variations" } },
          [
            _c("div", { staticClass: "card-header" }, [
              _c("h2", { staticClass: "mb-0" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "d-flex btn btn-link btn-block text-left collapsed",
                    attrs: {
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": "#variations",
                      "aria-expanded": "true",
                      "aria-controls": "collapseOne"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Phywe::Template.sbindingMoreVariations"
                          )
                        ) + " "
                      ),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.current.texts.name1) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "flex-fill ml-3 fa fa-caret-down" })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "collapse show", attrs: { id: "variations" } },
              [
                _c(
                  "div",
                  { staticClass: "card-body coloredRow px-0" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "mb-3 font-weight-bold d-none d-lg-flex table-header"
                      },
                      [
                        _c("div", { staticClass: "col-6 col-lg-1 pl-3" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getCurrentAttr) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-6 col-lg-2 text-right text-lg-left"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate("Phywe::Template.tableNr")
                                ) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.variationUnit == "EA"
                          ? [
                              _c("div", { staticClass: "col-lg-6 pl-lg-0" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Phywe::Template.tablePrice"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]
                          : [
                              _c("div", { staticClass: "col-lg-4 pl-lg-0" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Phywe::Template.tablePrice"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ],
                        _vm._v(" "),
                        _vm.variationUnit == "PK"
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-lg-2 text-lg-right" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Phywe::Template.tableInhalt"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-lg-3 mt-3 mt-lg-0 text-lg-right"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$translate("Phywe::Template.tableMenge")
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.variationsData.pack, function(variation) {
                      return _vm.variationUnit == "PK"
                        ? _c(
                            "div",
                            { staticClass: "row mb-3 align-items-center" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 col-lg-1 pl-3 font-weight-bold"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        variation.data.attributes[0].value
                                          .names[0].name
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 col-lg-2 text-right text-lg-left"
                                },
                                [
                                  _c("span", { staticClass: "d-lg-none" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Phywe::Template.globalArtikelNr"
                                        )
                                      ) + " "
                                    )
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("removepack")(
                                          variation.data.variation.number
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-lg-4 pl-lg-0" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      variation.data.prices.default.price
                                        .formatted
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemExclVAT"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                _c("span", { staticClass: "smaller" }, [
                                  _vm._v(
                                    "( " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          variation.data.prices.default.data
                                            .basePrice
                                        )
                                      ) +
                                      "  " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemInclVAT"
                                        )
                                      ) +
                                      ")"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-green" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Phywe::Template.singleEntspricht"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          variation.data.prices.default.price
                                            .value /
                                            variation.data.variation
                                              .unitsContained
                                        )
                                      ) +
                                      " /\n\n              " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Phywe::Template.singleUnitsS"
                                        )
                                      ) +
                                      "\n              -\n              " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Phywe::Template.singleSaving"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(variation.ersparnisProzent) +
                                      "%\n            "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-12 col-lg-2 text-lg-right"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Phywe::Template.globalInhalt"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                  _c("br", {
                                    staticClass: "d-none d-lg-block"
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        variation.data.variation.unitsContained
                                      )
                                    }
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Phywe::Template.singleUnitsS"
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 col-lg-3 mt-3 mt-lg-0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex justify-content-end"
                                    },
                                    [
                                      _vm.variations.pack.length > 0
                                        ? _c(
                                            "div",
                                            { staticClass: "input-unit mb-0" },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  staticClass:
                                                    "switch-box custom-select",
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.changeUnit(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        value: "PK",
                                                        selected: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Phywe::Template.singleUnitsP"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "EA" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Phywe::Template.singleUnitsS"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "add-to-basket-container"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "quantity-input-container mr-0 ml-2"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "qty-box d-flex h-100"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn qty-btn flex-fill d-flex justify-content-center align-items-center p-0",
                                                      attrs: {
                                                        "data-testing":
                                                          "quantity-btn-decrease",
                                                        "aria-label":
                                                          "Menge verringern"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.minusMenge(
                                                            variation
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-caret-left default-float",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.number",
                                                        value:
                                                          variation.quantity,
                                                        expression:
                                                          "variation.quantity",
                                                        modifiers: {
                                                          number: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "qty-input text-center flex-fill",
                                                    attrs: {
                                                      type: "text",
                                                      "aria-label":
                                                        "Mengeneingabe"
                                                    },
                                                    domProps: {
                                                      value: variation.quantity
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          variation,
                                                          "quantity",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function($event) {
                                                        return _vm.$forceUpdate()
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn qty-btn flex-fill d-flex justify-content-center align-items-center p-0",
                                                      attrs: {
                                                        "data-testing":
                                                          "quantity-btn-increase",
                                                        "aria-label":
                                                          "Menge erhöhen"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.plusMenge(
                                                            variation
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-caret-right default-float",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.variationsData.single, function(variation) {
                      return _vm.variationUnit == "EA"
                        ? _c(
                            "div",
                            { staticClass: "row mb-3 align-items-center" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 col-lg-1 pl-3 font-weight-bold"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        variation.data.attributes[0].value
                                          .names[0].name
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 col-lg-2 text-right text-lg-left"
                                },
                                [
                                  _c("span", { staticClass: "d-lg-none" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Phywe::Template.globalArtikelNr"
                                        )
                                      ) + " "
                                    )
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("removepack")(
                                          variation.data.variation.number
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-lg-6 pl-lg-0" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      variation.data.prices.default.price
                                        .formatted
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.itemExclVAT"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                _c("span", { staticClass: "smaller" }, [
                                  _vm._v(
                                    "( " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          variation.data.prices.default.data
                                            .basePrice
                                        )
                                      ) +
                                      "  " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.itemInclVAT"
                                        )
                                      ) +
                                      ")"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-12 col-lg-3 mt-3 mt-lg-0" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex justify-content-end"
                                    },
                                    [
                                      _vm.variations.pack.length > 0
                                        ? _c(
                                            "div",
                                            { staticClass: "input-unit mb-0" },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  staticClass:
                                                    "switch-box custom-select",
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.changeUnit(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "PK" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Phywe::Template.singleUnitsP"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        value: "EA",
                                                        selected: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Phywe::Template.singleUnitsS"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "add-to-basket-container"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "quantity-input-container mr-0 ml-2"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "qty-box d-flex h-100"
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn qty-btn flex-fill d-flex justify-content-center align-items-center p-0",
                                                      attrs: {
                                                        "data-testing":
                                                          "quantity-btn-decrease",
                                                        "aria-label":
                                                          "Menge verringern"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.minusMenge(
                                                            variation
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-caret-left default-float",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.number",
                                                        value:
                                                          variation.quantity,
                                                        expression:
                                                          "variation.quantity",
                                                        modifiers: {
                                                          number: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "qty-input text-center flex-fill",
                                                    attrs: {
                                                      type: "text",
                                                      "aria-label":
                                                        "Mengeneingabe"
                                                    },
                                                    domProps: {
                                                      value: variation.quantity
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          variation,
                                                          "quantity",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function($event) {
                                                        return _vm.$forceUpdate()
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn qty-btn flex-fill d-flex justify-content-center align-items-center p-0",
                                                      attrs: {
                                                        "data-testing":
                                                          "quantity-btn-increase",
                                                        "aria-label":
                                                          "Menge erhöhen"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.plusMenge(
                                                            variation
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-caret-right default-float",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm.variationUnit == "PK"
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary btn-appearance btn-large col-12 col-lg-3",
                                attrs: {
                                  disabled: _vm.isLoading || _vm.disabledPK
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.buyall(_vm.variationsData.pack)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemAddToBasket"
                                      )
                                    ) +
                                    "\n              "
                                ),
                                _vm.isLoading
                                  ? _c("i", {
                                      staticClass:
                                        "fa fa-spin fa-circle-o-notch float-none ml-2"
                                    })
                                  : _vm._e()
                              ]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.variationUnit == "EA"
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary btn-appearance btn-large col-12 col-lg-3",
                                attrs: {
                                  disabled: _vm.isLoading || _vm.disabeledSingle
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.buyall(_vm.variationsData.single)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemAddToBasket"
                                      )
                                    ) +
                                    "\n              "
                                ),
                                _vm.isLoading
                                  ? _c("i", {
                                      staticClass:
                                        "fa fa-spin fa-circle-o-notch float-none ml-2"
                                    })
                                  : _vm._e()
                              ]
                            )
                          ])
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.versuche.length > 0
      ? _c("div", { staticClass: "card", attrs: { "data-step": "versuche" } }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h2", { staticClass: "mb-0" }, [
              _c(
                "button",
                {
                  staticClass:
                    "d-flex btn btn-link btn-block text-left collapsed",
                  attrs: {
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#versuche",
                    "aria-expanded": "true",
                    "aria-controls": "collapseOne"
                  }
                },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$translate("Phywe::Template.sbindingVersuche"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "flex-fill ml-3 fa fa-caret-down" })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "collapse", attrs: { id: "versuche" } }, [
            _c("div", { staticClass: "card-body px-0" }, [
              _c("div", { staticClass: "grey p-4" }, [
                _c("div", { staticClass: "row mt-4 mb-4" }, [
                  _c(
                    "div",
                    { staticClass: "col-9 col-lg-6 font-weight-bold" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Phywe::Template.sbindingTableCell1")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-none d-lg-block col-lg-3 font-weight-bold"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Phywe::Template.sbindingTableCell2")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-none d-lg-block col-lg-3 font-weight-bold"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Phywe::Template.sbindingTableCell6")
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "itemslist" },
                  [
                    _vm._l(_vm.versuche, function(versuch) {
                      return [
                        _c("div", { staticClass: "row itemblocks mt-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-10 col-lg-6 order-0 order-lg-0"
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm._f("correctLang")(versuch, "url")
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm._f("correctLang")(versuch, "name")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-12 col-lg-3 order-2 order-lg-1"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "d-lg-none text-muted" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Phywe::Template.sbindingTableCell2"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("a", {
                                attrs: {
                                  href: _vm._f("correctLang")(versuch, "url")
                                },
                                domProps: {
                                  innerHTML: _vm._s(versuch.mappedTo)
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-12 col-lg-3 order-2 order-lg-1"
                            },
                            [
                              _vm.getCurricuLab(versuch.properties).length > 0
                                ? [
                                    _c(
                                      "span",
                                      { staticClass: "d-lg-none text-muted" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Phywe::Template.sbindingTableCell6"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getCurricuLab(
                                            versuch.properties
                                          )[0].value,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "img-fluid",
                                          attrs: {
                                            src:
                                              "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/curricuLAB-xsmall.png",
                                            alt: "curricuLAB",
                                            title: "curricuLAB"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]
                    })
                  ],
                  2
                )
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.lieferumfang.length > 0
      ? _c(
          "div",
          { staticClass: "card", attrs: { "data-step": "lieferumfang" } },
          [
            _c("div", { staticClass: "card-header" }, [
              _c("h2", { staticClass: "mb-0" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "d-flex btn btn-link btn-block text-left collapsed",
                    attrs: {
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": "#lieferumfang",
                      "aria-expanded": "true",
                      "aria-controls": "collapseOne"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Phywe::Template.sbindingLieferumfang")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "flex-fill ml-3 fa fa-caret-down" })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "collapse", attrs: { id: "lieferumfang" } },
              [
                _c("div", { staticClass: "card-body px-0" }, [
                  _c("div", { staticClass: "grey p-4" }, [
                    _c("div", { staticClass: "row mt-4 mb-4" }, [
                      _c(
                        "div",
                        { staticClass: "col-9 col-lg-9 font-weight-bold" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Phywe::Template.sbindingTableCell1"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-none d-lg-block col-lg-2 font-weight-bold"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Phywe::Template.sbindingTableCell2"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-3 d-lg-block col-lg-1 font-weight-bold"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$translate("Phywe::Template.gMenge"))
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "itemslist" },
                      [
                        _vm._l(_vm.lieferumfang, function(umfang) {
                          return [
                            _c("div", { staticClass: "row itemblocks mt-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-10 col-lg-9 order-0 order-lg-0"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm._f("correctLang")(
                                          umfang,
                                          "url"
                                        )
                                      }
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            umfang.more.data.texts.name1
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      umfang.more.data.attributes.length > 0
                                        ? [
                                            _vm._v(
                                              "\n                      |\n                      "
                                            ),
                                            _vm._l(
                                              umfang.more.data.attributes,
                                              function(attr) {
                                                return [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        attr.attribute.names
                                                          .name
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(
                                                    ":\n                        "
                                                  ),
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        attr.value.names.name
                                                      )
                                                    }
                                                  })
                                                ]
                                              }
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-lg-2 order-2 order-lg-1"
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-lg-none text-muted" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Phywe::Template.sbindingTableCell2"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("a", {
                                    attrs: {
                                      href: _vm._f("correctLang")(umfang, "url")
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        umfang.more.data.variation.number
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 col-lg-1 order-1 order-lg-2 d-flex align-items-center justify-content-center"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("numberFormat")(umfang.quantity)
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ])
                          ]
                        })
                      ],
                      2
                    )
                  ])
                ])
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.zubehoerData != null
      ? _c("div", { staticClass: "card", attrs: { "data-step": "zubehoer" } }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h2", { staticClass: "mb-0" }, [
              _c(
                "button",
                {
                  staticClass:
                    "d-flex btn btn-link btn-block text-left collapsed",
                  attrs: {
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#zubehoer",
                    "aria-expanded": "true",
                    "aria-controls": "collapseOne"
                  }
                },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Phywe::Template.sbindingGroupZubehor")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "flex-fill ml-3 fa fa-caret-down" })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse",
              attrs: { id: "zubehoer", "aria-labelledby": "Zubehoer" }
            },
            [
              _c("div", { staticClass: "card-body px-0" }, [
                _vm.zubehoer.notwendig.length > 0
                  ? _c(
                      "div",
                      { staticClass: "grey p-4" },
                      [
                        _c("i", {
                          staticClass:
                            "icon-warning-black table-icon d-none d-lg-block"
                        }),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Phywe::Template.sbindingZubehor2")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-red" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Phywe::Template.sbindingZubehorslogan2"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-4 mb-4" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-9 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell2"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-2 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell2"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "d-none d-lg-block col-lg-1 font-weight-bold"
                          })
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.zubehoer.notwendig, function(zubehoeritem) {
                          return [
                            _c("div", { staticClass: "row itemblocks mt-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-10 col-lg-9 order-0 order-lg-0"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm._f("correctLang")(
                                          zubehoeritem,
                                          "url"
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("correctLang")(
                                              zubehoeritem,
                                              "name"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-lg-2 order-2 order-lg-1"
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-lg-none text-muted" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Phywe::Template.sbindingTableCell2"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("a", {
                                    attrs: {
                                      href: _vm._f("correctLang")(
                                        zubehoeritem,
                                        "url"
                                      )
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(zubehoeritem.mappedTo)
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-2 col-lg-1 order-1 order-lg-2 d-flex align-items-center justify-content-center"
                                },
                                [
                                  zubehoeritem.isLoading
                                    ? [_vm._m(0, true)]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            on: {
                                              click: function($event) {
                                                return _vm.buyItem(
                                                  zubehoeritem.item
                                                    .mainVariationId,
                                                  zubehoeritem.texts,
                                                  zubehoeritem
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-add_shopping-black"
                                            })
                                          ]
                                        )
                                      ]
                                ],
                                2
                              )
                            ])
                          ]
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.zubehoer.empfohlen.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "grey p-4",
                        class: { "mt-5": _vm.zubehoer.notwendig.length > 0 }
                      },
                      [
                        _c("i", {
                          staticClass:
                            "icon-Mehrwert_black table-icon d-none d-lg-block text-green"
                        }),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Phywe::Template.sbindingZubehor")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-green" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Phywe::Template.sbindingZubehorslogan1"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-4 mb-4" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-9 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell1"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-2 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell2"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-1 font-weight-bold"
                            },
                            [_vm._v(" ")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "itemslist" },
                          [
                            _vm._l(_vm.zubehoer.empfohlen, function(
                              zubehoeritem
                            ) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "row itemblocks mt-3" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-10 col-lg-9 order-0 order-lg-0"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm._f("correctLang")(
                                                zubehoeritem,
                                                "url"
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm._f("correctLang")(
                                                    zubehoeritem,
                                                    "name"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-lg-2 order-2 order-lg-1"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "d-lg-none text-muted"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Phywe::Template.sbindingTableCell2"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("a", {
                                          attrs: {
                                            href: _vm._f("correctLang")(
                                              zubehoeritem,
                                              "url"
                                            )
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              zubehoeritem.mappedTo
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-2 col-lg-1 order-1 order-lg-2 d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        zubehoeritem.isLoading
                                          ? [_vm._m(1, true)]
                                          : [
                                              _c(
                                                "div",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.buyItem(
                                                        zubehoeritem.item
                                                          .mainVariationId,
                                                        zubehoeritem.texts,
                                                        zubehoeritem
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-add_shopping-black"
                                                  })
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.zubehoer.kompatibles.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "grey p-4",
                        class: {
                          "mt-5":
                            _vm.zubehoer.notwendig.length > 0 ||
                            _vm.zubehoer.empfohlen.length
                        }
                      },
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Phywe::Template.sbindingZubehor3")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "text-green" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Phywe::Template.sbindingZubehorslogan3"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-4 mb-4" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-9 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell1"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-2 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell2"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-1 font-weight-bold"
                            },
                            [_vm._v(" ")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "itemslist" },
                          [
                            _vm._l(_vm.zubehoer.kompatibles, function(
                              zubehoeritem
                            ) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "row itemblocks mt-3" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-10 col-lg-9 order-0 order-lg-0"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm._f("correctLang")(
                                                zubehoeritem,
                                                "url"
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm._f("correctLang")(
                                                    zubehoeritem,
                                                    "name"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-lg-2 order-2 order-lg-1"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "d-lg-none text-muted"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Phywe::Template.sbindingTableCell2"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("a", {
                                          attrs: {
                                            href: _vm._f("correctLang")(
                                              zubehoeritem,
                                              "url"
                                            )
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              zubehoeritem.mappedTo
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-2 col-lg-1 order-1 order-lg-2 d-flex align-items-center justify-content-center"
                                      },
                                      [
                                        zubehoeritem.isLoading
                                          ? [_vm._m(2, true)]
                                          : [
                                              _c(
                                                "div",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.buyItem(
                                                        zubehoeritem.item
                                                          .mainVariationId,
                                                        zubehoeritem.texts,
                                                        zubehoeritem
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-add_shopping-black"
                                                  })
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.media.length > 0 ||
    _vm.getCurricuLabBig(_vm.current.variationProperties).length > 0
      ? _c(
          "div",
          { staticClass: "card", attrs: { "data-step": "mediafiles" } },
          [
            _c("div", { staticClass: "card-header" }, [
              _c("h2", { staticClass: "mb-0" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "d-flex btn btn-link btn-block text-left collapsed",
                    attrs: {
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": "#media",
                      "aria-expanded": "true",
                      "aria-controls": "collapseOne"
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$translate("Phywe::Template.sbindingMedia"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "flex-fill ml-3 fa fa-caret-down" })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse",
                attrs: { id: "media", "aria-labelledby": "Mediafiles" }
              },
              [
                _c("div", { staticClass: "card-body px-0" }, [
                  _c(
                    "div",
                    { staticClass: "grey p-4" },
                    [
                      _c(
                        "div",
                        { staticClass: "row mt-0 mb-4 d-none d-lg-flex" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-12 col-lg-5 font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell0"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-2 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell4"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-2 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell3"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-none d-lg-block col-lg-1 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell5"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-lg-block col-lg-2 font-weight-bold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Phywe::Template.sbindingTableCell6"
                                  )
                                )
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.media, function(mediaFile) {
                        return [
                          mediaFile.fileExtension == "exe" ||
                          mediaFile.fileExtension == "msi" ||
                          mediaFile.fileExtension == "pkg" ||
                          mediaFile.fileExtension == "dmg"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "row itemblocks mt-3" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-10 col-lg-7 order-0 order-lg-0"
                                      },
                                      [
                                        _c("a", {
                                          staticClass: "cursor",
                                          attrs: {
                                            href: mediaFile.fileInternalComment,
                                            target: "_blank"
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              "(" +
                                                mediaFile.lang +
                                                ")" +
                                                " " +
                                                mediaFile.fileExternalComment
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-lg-2 order-2 order-lg-1"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "d-lg-none text-muted"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Phywe::Template.sbindingTableCell3"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-none d-lg-flex col-lg-1 order-1 order-lg-2 align-items-center justify-content-center"
                                      },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              mediaFile.fileExtension
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(3, true)
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "row itemblocks mt-3" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-10 col-lg-5 order-0 order-lg-0"
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "cursor",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              "(" +
                                                mediaFile.lang +
                                                ")" +
                                                " " +
                                                mediaFile.fileExternalComment
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getFileContent(
                                                mediaFile
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 col-lg-2" },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              mediaFile.fileName
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "d-lg-none" },
                                          [
                                            _vm._v("."),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  mediaFile.fileExtension
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-lg-2 order-2 order-lg-1"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "d-lg-none text-muted"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Phywe::Template.sbindingTableCell3"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                mediaFile.fileSize / 1000000
                                              ).toFixed(2)
                                            ) + " Mb"
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-none d-lg-flex col-lg-1 order-1 order-lg-2 align-items-center justify-content-center"
                                      },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              mediaFile.fileExtension
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(4, true)
                                  ]
                                )
                              ]
                        ]
                      }),
                      _vm._v(" "),
                      _vm.getCurricuLabBig(_vm.current.variationProperties)
                        .length > 0
                        ? [
                            _c("div", { staticClass: "row itemblocks mt-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-10 col-lg-5 order-0 order-lg-0"
                                },
                                [
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.current.texts.name1))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(5),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-lg-2 order-2 order-lg-1"
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-lg-none text-muted" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Phywe::Template.sbindingTableCell3"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("-")])
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(6),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-lg-flex col-lg-2 order-1 order-lg-2 align-items-center justify-content-start"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getCurricuLabBig(
                                          _vm.current.variationProperties
                                        )[0],
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/curricuLAB-xsmall.png"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "fa fa-spin fa-circle-o-notch" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "fa fa-spin fa-circle-o-notch" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "fa fa-spin fa-circle-o-notch" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-lg-flex col-lg-2 order-1 order-lg-2 align-items-center justify-content-start"
      },
      [_c("div", [_vm._v(" - ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-lg-flex col-lg-2 order-1 order-lg-2 align-items-center justify-content-start"
      },
      [_c("div", [_vm._v(" - ")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-lg-2" }, [
      _c("span", [_vm._v("-")]),
      _vm._v(" "),
      _c("span", { staticClass: "d-lg-none" }, [_vm._v(".H5P")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-none d-lg-flex col-lg-1 order-1 order-lg-2 align-items-center justify-content-center"
      },
      [_c("div", [_vm._v(".H5P")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }